import { EditFilled } from "@ant-design/icons";
import { Button, InputNumber, Modal, Space } from "antd";
import { doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export default function HotprintPopup(props) {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [ARM, setARM] = useState(initialState);
   const [AT, setAT] = useState(initialState);
   const [MPM, setMPM] = useState(initialState);
   const [PCPM, setPCPM] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setARM(props.adjustmentRunningMeters);
      setAT(props.adjustmentTime);
      setMPM(props.meterPerMinute);
      setPCPM(props.printCostsPerHour);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setARM(initialState);
      setAT(initialState);
      setMPM(initialState);
      setPCPM(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "hotprint", props.id);
      await updateDoc(ref, {
         adjustmentRunningMeters: ARM,
         adjustmentTime: AT,
         meterPerMinute: MPM,
         printCostsPerHour: PCPM,
         id: props.id,
      })
         .then(() => {
            setIsModalOpen(true);
            setARM(initialState);
            setAT(initialState);
            setMPM(initialState);
            setPCPM(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((error) => {
            Notification("error", "Login Error", error.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={700} title={"Hotprint settings"} open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space direction="vertical">
               <InputNumber addonBefore="Adjustment Running Meters :" value={ARM} style={{ width: "100%" }} onChange={setARM} />
               <InputNumber addonBefore="Adjustment Time :" value={AT} style={{ width: "100%" }} onChange={setAT} />
               <InputNumber addonBefore="Meters Per Minute :" value={MPM} style={{ width: "100%" }} onChange={setMPM} />
               <InputNumber addonBefore="Print Costs per Hour :" value={PCPM} style={{ width: "100%" }} onChange={setPCPM} />
            </Space>
         </Modal>
      </>
   );
}
